import { useQuery, type UseQueryOptions } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { LANDLORD_SELF_INVITE_PATH } from 'src/services/api/onboarding/invites/constants';
import type { ILandlordOnboardInvite } from 'src/api/onboard-api';

export type IGetOnboardInvitesResponse = {
    invites: ILandlordOnboardInvite[];
}

export const useInvites = (options?: Pick<UseQueryOptions, 'enabled'>) => {
    return useQuery(
        [queryKeys.onboardingInvites],
        async () => {
            const res = await apiClient(LANDLORD_SELF_INVITE_PATH).json<IGetOnboardInvitesResponse>();
            return res.invites;
        }, {
            enabled: options?.enabled,
        }
    );
};